/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  LoadCanvasTemplateNoReload,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import ReLoadIcon from "../../components/Icons/ReLoadIcon";
import Layout from "../../components/Layout/Layout";

export default function ContactUs() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const [captchaValue, setCaptchaValue] = useState("");
  const [captchaError, setCaptchaError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    console.log("Form Data Submitted: ", data);
    // Handle form submission logic here
    if (captchaValue?.length !== 0) {
      if (validateCaptcha(captchaValue) === true) {
        setLoading(true);
        try {
          const option = {
            method: "POST",
            data: data,
          };
          const res = await callApi(apiUrl.add_message, option);
          if (res?.status === true) {
            setLoading(false);
            toast.success(res?.message);
            reset();
            setCaptchaValue("");
          } else {
            setLoading(false);
            toast.error(res?.message);
          }
        } catch (err) {
          setLoading(false);
          // console.log(err);
        } finally {
          setLoading(false);
        }
        setCaptchaError("");
      } else {
        setCaptchaError("Captcha is incorrect");
      }
    } else {
      setCaptchaError("Please enter captcha");
    }
  };

  useEffect(() => {
    // Initialize captcha when the component mounts
    loadCaptchaEnginge(6); // 6 characters for captcha length
  }, []);

  return (
    <>
      <Layout>
        {/* Download-Free-App-section-end  */}
        <section className="contact_page_section my-5" id="Contact-Us">
          <div className="container">
            <div className="contact_inner">
              <div className="contact_form mt-5">
                <div className="section_title">
                  <h2>
                    Leave a <span>message</span>
                  </h2>
                  <p>Fill up form below, our team will get back soon</p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Name"
                      className="form-control"
                      {...register("name", { required: "Name is required" })}
                    />
                    {errors.name && (
                      <span className="text-danger">{errors.name.message}</span>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="email"
                      placeholder="Email"
                      className="form-control"
                      {...register("email", {
                        required: "Email is required",
                        pattern: {
                          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                          message: "Invalid email address",
                        },
                      })}
                    />
                    {errors.email && (
                      <span className="text-danger">
                        {errors.email.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Phone"
                      className="form-control"
                      {...register("phone", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Invalid phone number",
                        },
                      })}
                    />
                    {errors.phone && (
                      <span className="text-danger">
                        {errors.phone.message}
                      </span>
                    )}
                  </div>

                  <div className="form-group">
                    <textarea
                      className="form-control"
                      placeholder="Your message"
                      {...register("message", {
                        required: "Message is required",
                      })}
                    />
                    {errors.message && (
                      <span className="text-danger text-start">
                        {errors.message.message}
                      </span>
                    )}
                  </div>

                  {/* Captcha Section */}
                  <div className="form-group mb-3">
                    <div className="reload">
                      <LoadCanvasTemplateNoReload />
                      <ReLoadIcon />
                    </div>
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      className="form-control"
                      value={captchaValue}
                      onChange={(e) => setCaptchaValue(e.target.value)}
                    />
                    {captchaError && (
                      <span className="text-danger">{captchaError}</span>
                    )}
                  </div>

                  <div className="form-group mb-0 text-center">
                    <button type="submit" className="btn puprple_btn">
                      {loading ? (
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "SEND MESSAGE"
                      )}
                    </button>
                  </div>
                </form>
              </div>
              <div className="contact_info">
                <div className="icon">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/images/contact_message_icon.png`}
                    alt="image"
                  />
                </div>
                <div className="section_title">
                  <h2>
                    Have any <span>question?</span>
                  </h2>
                  <p>
                    If you have any question about our product, service, payment
                    or company, Visit our <a href="faq.html">FAQs page.</a>
                  </p>
                </div>
                <a href="faq.html" className="btn puprple_btn">
                  READ FAQ
                </a>
                <ul className="contact_info_list">
                  <li>
                    <div className="img">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/mail_icon.png`}
                        alt="image"
                      />
                    </div>
                    <div className="text">
                      <span>Email Us</span>
                      <a href="mailto:support@dizixpert.com">
                        support@dizixpert.com
                      </a>
                    </div>
                  </li>
                  <li>
                    <div className="img">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/call_icon.png`}
                        alt="image"
                      />
                    </div>
                    <div className="text">
                      <span>Call Us</span>
                      <a href="tel:+919351207293">+919351111477</a>
                    </div>
                  </li>
                  <li>
                    <div className="img">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/location_icon.png`}
                        alt="image"
                      />
                    </div>
                    <div className="text">
                      <span>Address</span>
                      <p>
                        Dizixpert Techno Services Pvt. Ltd., Sri Ganganagar
                        Road, Jaipur Jodhpur By-Pass, Bikaner(Raj.) - 334001
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
}
